// Formats a WGS84 latitude/longitude as degrees-minutes-seconds with hemisphere
// letters, e.g. `53°20'59.3"N 6°15'37.1"W`. This is the display sibling of the
// decimal-degrees grid-ref format (GridRef.LatLon); seconds carry one decimal
// place (~3 m), comparable to the existing decimal-degrees precision.
//
// Kept free of mapbox-gl / proj4 imports so it can be unit-tested in isolation.

export function formatDms(lat: number, lng: number): string {
  return `${dmsComponent(lat, true)} ${dmsComponent(lng, false)}`;
}

function dmsComponent(value: number, isLatitude: boolean): string {
  const hemisphere = isLatitude ? (value < 0 ? 'S' : 'N') : (value < 0 ? 'W' : 'E');
  // Round to the nearest 0.1" in integer space so a value like 59.96" carries
  // into the minutes/degrees rather than printing an invalid 60.0".
  const totalTenthSeconds = Math.round(Math.abs(value) * 3600 * 10);
  const degrees = Math.floor(totalTenthSeconds / 36000); // 3600" * 10
  const remainderAfterDegrees = totalTenthSeconds % 36000;
  const minutes = Math.floor(remainderAfterDegrees / 600); // 60" * 10
  const seconds = (remainderAfterDegrees % 600) / 10;
  // toFixed always uses a dot decimal separator, regardless of locale.
  return `${degrees}°${minutes}'${seconds.toFixed(1)}"${hemisphere}`;
}
